var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100 5105 c-520 -77 -946 -466 -1063 -970 -35 -151 -37 -217 -37 -1578 0 -1441 1 -1450 49 -1622 120 -423 463 -766 886 -886 172 -48 181 -49 1622 -49 864 0 1380 4 1430 10 295 39 546 162 754 369 207 208 330 459 369 754 14 107 14 2747 0 2854 -39 295 -162 546 -369 754 -208 207 -459 330 -754 369 -122 16 -2777 11 -2887 -5z m1900 -1375 c625 -18 786 -32 878 -79 137 -70 212 -206 243 -438 17 -124 23 -968 9 -1172 -17 -251 -60 -395 -145 -490 -48 -53 -155 -106 -242 -120 -382 -59 -2164 -49 -2408 14 -171 45 -264 141 -310 322 -30 118 -37 221 -42 678 -8 674 9 862 92 1032 55 111 152 184 281 211 66 14 377 32 718 41 405 11 547 12 926 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230 2595 c0 -256 3 -464 8 -462 4 3 194 105 422 227 228 122 418 225 422 229 5 4 -800 453 -843 469 -5 2 -9 -197 -9 -463z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f054da0d84ec5e7f5d5e4c6d70234937.svg";
export { ForwardRef as ReactComponent };